module.exports = __webpack_public_path__ + "static/img/hr_visitor_carddesc06.56763289.png";